import { HostService } from '../host/host.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class ProductService {
  host: string;
  constructor(
    private hostService: HostService,
    private http: HttpClient
  ) {
    this.host = this.hostService.host;
  }

  getOrderProduct(id,orderType,orderProg) {
    return this.http.get(this.hostService.host + 'order/elements/' +id,{params:{orderType,orderProg}})
  }
  getProductCompositions(idProduct) {
    return this.http.get(this.hostService.host + 'ingredients/compositions/element/' + idProduct)
  }
  getProductSupplements(idProduct) {
    return this.http.get(this.hostService.host + 'ingredients/supplements/element/' + idProduct)
  }
  getProductOptionsIngredient(idProduct) {
    return this.http.get(this.hostService.host + 'ingredients/optionsIngredient/element/' + idProduct)
  }
  getActiveProductByFamily(idFamily, orderType,orderProg) {
    return this.http.get(this.hostService.host + 'elements/active/family/' + idFamily + '/orderType/' + orderType,{params:{orderProg}});
  }
  getActiveProductBySearch(key, orderType,orderProg) {
    return this.http.get(this.hostService.host + 'elements2/active/orderType/' + orderType + '/key/' + key,{params:{orderProg}});
  }
  getElementByCompositions(ingredients, idOrderType,orderProg) {
    return this.http.get(this.hostService.host + 'elements/search/compositions',{params:{orderProg,ingredients:ingredients.join(','),idOrderType}});
  }
  getBestSales(orderType,orderProg) {
    return this.http.get(this.hostService.host + 'elements/bestSales2/orderType/' + orderType,{params:{orderProg}});
  }
}
